import auth from "./auth";
import me from "./me";
import user from "./public/user";

export default {
  ...auth,
  ...me,
  ...user
};
